import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: "Blog", path: "/artikel" },
    { name: "About", path: "/about" },
  ];

  return (
    <div
      role="banner"
      className="fixed top-0 left-0 z-50 w-full bg-transparent px-5 pointer-events-none sm:px-8 lg:px-12 xl:px-[72px]"
      style={{ position: "absolute", top: 0, right: 0, left: 0, height: "80px" }}
    >
      <div className="flex w-full items-center justify-between py-5 pointer-events-auto">
        {/* Logo */}
        <Link
          to="/"
          className="text-3xl md:text-4xl font-extrabold tracking-wide text-white hover:text-orange-500 transition"
        >
          Hello! Welcome
          <span className="text-orange-500 block text-2xl md:text-3xl hover:text-amber-400">
            👋 My Portfolio
          </span>
        </Link>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-10 pointer-events-auto">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.name}
                to={link.path}
                className={`relative group text-base md:text-lg font-semibold uppercase tracking-wide transition-all duration-300 ${
                  isActive
                    ? "text-orange-500 drop-shadow-[0_0_10px_rgba(249,115,22,0.9)]"
                    : "text-gray-200 hover:text-orange-500"
                }`}
              >
                {link.name}

                {/* 🔥 Animated underline */}
                <span
                  className={`absolute -bottom-1 left-0 w-full h-[2px] rounded-full transition-all duration-300 ease-out origin-left ${
                    isActive
                      ? "bg-orange-500 scale-x-100"
                      : "bg-orange-500 scale-x-0 group-hover:scale-x-100"
                  }`}
                ></span>
              </Link>
            );
          })}
        </nav>

        

      {/* Mobile Toggle */}
      <button
        className="md:hidden text-white hover:text-orange-500 transition"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <X size={30} /> : <Menu size={30} />}
      </button>
    </div>

      {/* Mobile Menu */ }
  {
    isOpen && (
      <nav className="md:hidden bg-slate-400/95 backdrop-blur-md border-t border-slate-200 flex flex-col items-center py-6 space-y-4 pointer-events-auto">
        {navLinks.map((link) => (
          <Link
            key={link.name}
            to={link.path}
            onClick={() => setIsOpen(false)}
            className={`text-lg uppercase font-medium transition ${location.pathname === link.path
              ? "text-orange-500"
              : "text-gray-300 hover:text-white"
              }`}
          >
            {link.name}
          </Link>
        ))}
      </nav>
    )
  }
    </div>
  );
};

export default Header;
